<template>
  <section class="UsersView">
    <div class="container">
      <div class="columns">
        <div class="column is-10 is-offset-1">
          <h2>Lista użytkowników</h2>
          <users-table @user-click="$emit('user-click', $event)" @order-click="$emit('order-click', $event)"/>
        </div>
      </div>
    </div>
    <Footer/>
  </section>
</template>

<script>
import Footer from '@/components/Footer'
import UsersTable from '@/components/tables/UsersTable'

export default {
  name: 'UsersView',
  components: {
    UsersTable,
    Footer
  }
}
</script>

<style lang="scss" scoped>
.UsersView {
  h2 {
    margin-top: 30px;
    margin-bottom: 20px;
    font-size: 30px;
  }
}
</style>